import { inject, readonly, ref } from 'vue';

export const LANDING_VERSION_INJECTION_KEY = Symbol('landingVersion');
export const DEFAULT_LANDING_VERSION = 'B';

// 仅依据预览开关与 URL query 解析版本。
// 不得读取 cookie / localStorage / 用户 ID / 随机数 / 远程配置。
// allowOverride=false 时恒定返回默认版本（当前为 B：无 query / 非法 query 即渲染 B）。
export function resolveLandingPreviewVersion(queryValue, allowOverride) {
  if (!allowOverride) {
    return DEFAULT_LANDING_VERSION;
  }

  // 缺失、数组或非法类型一律回退默认版本（当前为 B）
  if (typeof queryValue !== 'string') {
    return DEFAULT_LANDING_VERSION;
  }

  const normalized = queryValue.trim().toLowerCase();
  if (normalized === 'a') {
    return 'A';
  }
  if (normalized === 'b') {
    return 'B';
  }

  return DEFAULT_LANDING_VERSION;
}

// 在 Provider 子树内返回注入的只读版本 ref；
// 在 Provider 外（或尚未 provide）返回只读默认版本（当前为 B），不抛错。
export function useLandingVersion() {
  const injected = inject(LANDING_VERSION_INJECTION_KEY, null);
  if (injected === null || injected === undefined) {
    return readonly(ref(DEFAULT_LANDING_VERSION));
  }
  return injected;
}
